// src/components/SwitchToggle.js
import React from 'react';

export default function SwitchToggle({ checked, onChange, disabled = false }) {
    return (
        <label className="relative inline-block w-10 h-6">
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                className="opacity-0 w-0 h-0"
            />
            <span
                className={`
          absolute cursor-pointer top-0 left-0 right-0 bottom-0
          bg-gray-300 rounded-full transition
          ${checked ? 'bg-green-700' : 'bg-gray-400'}
        `}
            ></span>
            <span
                className={`
          absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition
          ${checked ? 'translate-x-4' : ''}
        `}
            ></span>
        </label>
    );
}
